export default function( elem, selector, eventName, handler ) {
  elem.addEventListener( eventName, function( ev ) {
    let { target } = ev;

    while ( target && target !== elem ) {
      if ( target.matches( selector ) ) {
        handler.call( target, ev, target );
      }

      target = target.parentNode;
    }
  });
}
